import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const CounterDisplay = () => {
  const [count, setCount] = useState(42);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* COUNTER DISPLAYS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Counter Displays</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Counter</label>
            <div className="text-center p-4 bg-slate-950 rounded border border-slate-600">
              <p className="text-4xl font-bold text-slate-200">{count}</p>
              <p className="text-xs text-slate-500 mt-2">items</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="text-center p-4 bg-slate-950 rounded">
  <p className="text-4xl font-bold">{count}</p>
  <p className="text-xs text-slate-500">items</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Unit</label>
            <div className="text-center p-4 bg-slate-950 rounded border border-slate-600">
              <div className="text-3xl font-bold text-slate-200">
                <span>$</span>{(count * 5).toLocaleString()}
              </div>
              <p className="text-xs text-slate-500 mt-2">Total value</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="text-center p-4">
  <div className="text-3xl font-bold">
    <span>$</span>{value}
  </div>
  <p className="text-xs">Total</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Circular Counter</label>
            <div className="flex items-center justify-center">
              <div className="relative w-24 h-24">
                <svg className="w-full h-full" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="45" fill="none" stroke="#334155" strokeWidth="4"/>
                  <circle cx="50" cy="50" r="45" fill="none" stroke="#06B6D4" strokeWidth="4" strokeDasharray={`${(count/100)*282.7} 282.7`} style={{transform: "rotate(-90deg)", transformOrigin: "50% 50%"}}/>
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center">
                    <p className="text-xl font-bold">{count}%</p>
                  </div>
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative w-24 h-24">
  <svg viewBox="0 0 100 100">
    <circle cx="50" cy="50" r="45" strokeDasharray={...} />
  </svg>
  <div className="absolute inset-0 flex items-center">
    {value}%
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Inline Counter</label>
            <div className="inline-flex items-baseline gap-1 px-2 py-1 bg-slate-950 rounded border border-slate-600">
              <span className="text-2xl font-bold text-amber-400">{count}</span>
              <span className="text-xs text-slate-500">out of 100</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="inline-flex items-baseline gap-1">
  <span className="text-2xl font-bold text-amber-400">{count}</span>
  <span className="text-xs">out of 100</span>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Colored Counter</label>
            <div className="text-center p-3 bg-gradient-to-br from-amber-900 to-slate-900 rounded border border-amber-600">
              <p className="text-3xl font-bold text-amber-300">{count}</p>
              <p className="text-xs text-amber-400 mt-1">Active users</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-3 bg-gradient-to-br from-amber-900">
  <p className="text-3xl font-bold text-amber-300">{count}</p>
  <p className="text-amber-400">Active users</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Comparison</label>
            <div className="grid grid-cols-2 gap-2">
              <div className="text-center p-2 bg-slate-950 rounded border border-slate-600">
                <p className="text-lg font-bold text-amber-400">{count}</p>
                <p className="text-xs text-slate-500">This month</p>
              </div>
              <div className="text-center p-2 bg-slate-950 rounded border border-slate-600">
                <p className="text-lg font-bold text-slate-400">{count - 10}</p>
                <p className="text-xs text-slate-500">Last month</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="grid grid-cols-2 gap-2">
  <div className="text-center">
    <p className="text-lg font-bold">{current}</p>
    <p className="text-xs">This month</p>
  </div>
  <div className="text-center">
    <p className="text-lg font-bold">{last}</p>
    <p className="text-xs">Last month</p>
  </div>
</div>`} />
          </div>
        </div>
      </div>

      {/* ANIMATED COUNTERS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Animated Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Pulse Counter</label>
            <div className="text-center p-4 bg-slate-950 rounded border border-slate-600 animate-pulse">
              <p className="text-4xl font-bold">...{count}</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-4 bg-slate-950 rounded animate-pulse">
  <p className="text-4xl font-bold">...{count}</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multi Stat Display</label>
            <div className="grid grid-cols-3 gap-2">
              {[{label: "Visitors", val: count*10}, {label: "Sales", val: count*5}, {label: "Churn", val: Math.floor(count/2)}].map(stat => (
                <div key={stat.label} className="text-center p-2 bg-slate-950 rounded border border-slate-600">
                  <p className="text-xl font-bold text-slate-200">{stat.val}</p>
                  <p className="text-xs text-slate-500">{stat.label}</p>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="grid grid-cols-3 gap-2">
  {stats.map(s => (
    <div className="text-center p-2 rounded">
      <p className="text-xl font-bold">{s.val}</p>
      <p className="text-xs">{s.label}</p>
    </div>
  ))}
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterDisplay;


